// Vendor
import $ from "jquery";

// Scroll to and on scroll animations
class Scrolling {
	constructor() {
		// elements
		this.$scrollElements = $(".scroll-animation, .h-underline");

		// classes
		this.scrollElementActiveCls = "in-viewport animated";

		// init functions
		this.attachEvents();
	}

	attachEvents() {
		// scorll to anchor binding
		$(document).on("click", "a.scroll-to", event => {
			event.preventDefault();
			let $anchor = $(event.target);
			this.scrollToElement($anchor.attr("href"));
		});

		// on scroll active sections
		$(window).on('scroll', () => {
			this.activeScrollSection();
		});
		$(window).on('load', () => {
			this.activeScrollSection("load");
		});
	}

	scrollToElement(id) {
		let offsetTop = $(id).offset().top;
		$("html, body")
			.stop()
			.animate(
				{
					scrollTop: offsetTop
				},
				offsetTop
			);
	}

	activeScrollSection(context) {
		let division = $(window).height() > $(window).width() ? 1.25 : 2;
		let scrollTop = $(window).scrollTop();
		let viewportMiddle = $(window).height() / division; //default trigger position

		this.$scrollElements.each((i, section) => {
			let $section = $(section);
			let sectionOffset = $section.offset().top;
			//let sectionViewportTrigger = $section.data('scroll-animation');

			if (context === "load") {
				setTimeout(() => {
					if (sectionOffset <= scrollTop + $(window).height()) {
						$section.addClass(this.scrollElementActiveCls);
					}
				}, 500);
			} else {
				if (scrollTop > sectionOffset - viewportMiddle) {
					$section.addClass(this.scrollElementActiveCls);
				}
			}
		});
	}
}

new Scrolling();
